/* Effet de réduction de l'en-tête au défilement + menu mobile compact.
   Déplacé tel quel depuis sections/header.liquid (chargé en defer, mis en cache). */
    (function() {
      var html = document.documentElement;
      var wrapper = document.querySelector('.header-wrapper--scroll-effect');
      if (!wrapper) return;

      if (window.nadiHeaderScrollEffect && typeof window.nadiHeaderScrollEffect.destroy === 'function') {
        window.nadiHeaderScrollEffect.destroy();
      }

      var animationId = null;
      var isScrolled = false;
      var ticking = false;
      var overlayEnabled = false;
      var DURATION = 400;
      var RADIUS_DURATION = 180;
      var SCROLL_THRESHOLD = 50;
      var PROPS = {
        width: [100, 95],
        radius: [0, 1],
        bgOpacity: [0, 0.9],
        blur: [0, 1],
        shadow: [0, 1],
        marginTop: [0, 0.8],
        marginX: [0, 1]
      };
      var current = { width: 100, radius: 0, bgOpacity: 0, blur: 0, shadow: 0, marginTop: 0, marginX: 0 };

      function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function lerp(from, to, progress) {
        return from + (to - from) * easeOutQuart(progress);
      }

      function setVars() {
        html.style.setProperty('--header-width', current.width);
        html.style.setProperty('--header-radius', current.radius);
        html.style.setProperty('--header-bg-opacity', current.bgOpacity);
        html.style.setProperty('--header-blur', current.blur);
        html.style.setProperty('--header-shadow', current.shadow);
        html.style.setProperty('--header-margin-top', current.marginTop);
        html.style.setProperty('--header-margin-x', current.marginX);
      }

	      function setWrapperBg(scrolled) {
	        if (scrolled) {
	          html.style.setProperty('--header-wrapper-bg', 'transparent');
	        } else {
	          html.style.removeProperty('--header-wrapper-bg');
	        }
	        wrapper.classList.toggle('header-wrapper--scrolled', scrolled);
	        if (overlayEnabled) {
	          document.body.classList.toggle('header-overlay-top', !scrolled);
	        }
	      }

	      function isMobileMenuActive() {
	        var drawerDetails = document.getElementById('Details-menu-drawer-container');
	        if (!drawerDetails) return false;

	        var state = drawerDetails.dataset.drawerState;
	        return drawerDetails.hasAttribute('open') || state === 'opening' || state === 'open' || state === 'closing';
	      }

	      function animateTo(scrolled) {
	        if (isMobileMenuActive()) return;
	        if (isScrolled === scrolled) return;
	        isScrolled = scrolled;
	        setWrapperBg(scrolled);

        var start = Object.assign({}, current);
        var target = {};
        Object.keys(PROPS).forEach(function(key) {
          target[key] = scrolled ? PROPS[key][1] : PROPS[key][0];
        });

        var startTime = performance.now();

        function tick(now) {
          var elapsed = now - startTime;
          var progress = Math.min(elapsed / DURATION, 1);
          var radiusProgress = Math.min(elapsed / RADIUS_DURATION, 1);

          Object.keys(PROPS).forEach(function(key) {
            current[key] = lerp(start[key], target[key], key === 'radius' ? radiusProgress : progress);
          });
          setVars();

          if (progress < 1) {
            animationId = requestAnimationFrame(tick);
          }
        }

        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(tick);
      }

	      function onScroll() {
	        if (isMobileMenuActive()) return;

	        if (!ticking) {
	          requestAnimationFrame(function() {
	            if (isMobileMenuActive()) {
	              ticking = false;
	              return;
	            }

	            animateTo(window.scrollY > SCROLL_THRESHOLD);
	            ticking = false;
	          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });

      function detectOverlay() {
        var main = document.getElementById('MainContent');
        var first = main && main.querySelector(':scope > .shopify-section');
        var marker = first && first.querySelector('[data-header-overlay]');
        overlayEnabled = !!(first && marker);
        document.body.classList.toggle('header-overlay-enabled', overlayEnabled);
        document.body.classList.toggle('header-overlay-invert', overlayEnabled && marker.hasAttribute('data-header-overlay-invert'));
        if (!overlayEnabled) {
          document.body.classList.remove('header-overlay-top');
        }
        setWrapperBg(window.scrollY > SCROLL_THRESHOLD);
      }
      if (document.readyState !== 'loading') {
        detectOverlay();
      } else {
        document.addEventListener('DOMContentLoaded', detectOverlay);
      }

      if (window.scrollY > SCROLL_THRESHOLD) {
        Object.keys(PROPS).forEach(function(key) {
          current[key] = PROPS[key][1];
        });
        isScrolled = true;
        setVars();
        setWrapperBg(true);
      } else {
        wrapper.classList.remove('header-wrapper--scrolled');
        setWrapperBg(false);
      }

      window.nadiHeaderScrollEffect = {
        destroy: function() {
          window.removeEventListener('scroll', onScroll);
          if (animationId) cancelAnimationFrame(animationId);
        }
      };
    })();

	    (function() {
	      if (window.nadiCompactMenuFlushRemove) {
	        window.nadiCompactMenuFlushRemove();
	      }

	      var headerWrapper = document.querySelector('.header-wrapper--scroll-effect');
	      var headerContainer = headerWrapper && headerWrapper.querySelector('.header-container');
	      var details = document.getElementById('Details-menu-drawer-container');
	      if (!headerWrapper || !headerContainer || !details) return;

	      var CLOSE_DURATION = 320;
	      var wasActive = false;
	      var closingTimeout = null;
	      var resizeObserver = null;
	      var resizeFrame = null;

	      function getViewportHeight() {
	        return (window.visualViewport && window.visualViewport.height) || window.innerHeight || document.documentElement.clientHeight;
	      }

	      function setMetrics() {
	        var menuTop = headerContainer.getBoundingClientRect().height;
	        var viewportHeight = getViewportHeight();

	        document.documentElement.style.setProperty('--nadi-menu-top', menuTop + 'px');

	        if (viewportHeight) {
	          document.documentElement.style.setProperty('--drawer-viewport-height', viewportHeight + 'px');
	          document.documentElement.style.setProperty('--viewport-height', viewportHeight + 'px');
	        }
	      }

	      function getDrawerState() {
	        if (details.dataset.drawerState) return details.dataset.drawerState;
	        if (details.classList.contains('drawer-opening')) return 'opening';
	        if (details.classList.contains('drawer-open')) return 'open';
	        if (details.classList.contains('drawer-closing')) return 'closing';
	        return details.hasAttribute('open') ? 'open' : 'closed';
	      }

	      function sync() {
	        setMetrics();

	        var compact = headerWrapper.classList.contains('header-wrapper--scrolled');
	        var state = getDrawerState();
	        // Header stays flush full-width only while the menu is open/opening.
	        // As soon as it starts closing, release it so it shrinks back to the
	        // capsule in sync with the panel sliding out (no late jump/judder).
	        var open = compact && (state === 'opening' || state === 'open');
	        var closing = compact && state === 'closing';

	        if (open) {
	          clearTimeout(closingTimeout);
	          document.body.classList.remove('mobile-menu-is-closing');
	        } else if (closing || wasActive) {
	          clearTimeout(closingTimeout);
	          document.body.classList.add('mobile-menu-is-closing');
	          closingTimeout = setTimeout(function() {
	            document.body.classList.remove('mobile-menu-is-closing');
	          }, CLOSE_DURATION + 50);
	        } else {
	          clearTimeout(closingTimeout);
	          document.body.classList.remove('mobile-menu-is-closing');
	        }

	        document.body.classList.toggle('mobile-menu-is-active', open);
	        document.body.classList.remove('nadi-compact-menu-flush-active');
	        document.body.classList.remove('nadi-compact-menu-flush-closing');
	        wasActive = open;
	      }

	      function scheduleResizeSync() {
	        if (resizeFrame) return;
	        resizeFrame = requestAnimationFrame(function() {
	          resizeFrame = null;
	          sync();
	        });
	      }

	      var observer = new MutationObserver(sync);
	      observer.observe(headerWrapper, { attributes: true, attributeFilter: ['class'] });
	      observer.observe(details, { attributes: true, attributeFilter: ['open', 'class', 'data-drawer-state'] });

	      if ('ResizeObserver' in window) {
	        resizeObserver = new ResizeObserver(scheduleResizeSync);
	        resizeObserver.observe(headerContainer);
	        resizeObserver.observe(headerWrapper);
	      }

	      window.addEventListener('scroll', sync, { passive: true });
	      window.addEventListener('resize', sync);
	      window.visualViewport && window.visualViewport.addEventListener('resize', sync);
	      window.visualViewport && window.visualViewport.addEventListener('scroll', sync);
	      details.addEventListener('drawer:state-change', sync);

	      window.nadiCompactMenuFlushRemove = function() {
	        observer.disconnect();
	        resizeObserver && resizeObserver.disconnect();
	        clearTimeout(closingTimeout);
	        if (resizeFrame) cancelAnimationFrame(resizeFrame);
	        window.removeEventListener('scroll', sync);
	        window.removeEventListener('resize', sync);
	        window.visualViewport && window.visualViewport.removeEventListener('resize', sync);
	        window.visualViewport && window.visualViewport.removeEventListener('scroll', sync);
	        details.removeEventListener('drawer:state-change', sync);
	        document.body.classList.remove('mobile-menu-is-active');
	        document.body.classList.remove('mobile-menu-is-closing');
	        document.body.classList.remove('nadi-compact-menu-flush-active');
	        document.body.classList.remove('nadi-compact-menu-flush-closing');
	      };

	      sync();
	    })();
